var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidName(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B9B9B",
    fillRule: "evenodd",
    d: "M12.741 15.8l-4.665-4.665-5.184 5.184-2.751-2.75 5.185-5.185-4.641-4.64L3.257 1.17l4.641 4.64 5.171-5.17 2.75 2.75-5.17 5.171 4.664 4.665z"
  })));
}
export default SvgInvalidName;